import request from '@/utils/request'; // 临港需求js
// ----------------临港平台投保意向单管理列表查询

export function rinkoPolicyQuery(query) {
  return request({
    url: '/ecargopolicy/rinko/rinkoPolicyQuery',
    method: 'post',
    data: query
  });
} // 临港平台投保单管理分页查询

export function rinkPolicyQueryPageList(data) {
  return request({
    url: '/ecargopolicy/rinko/rinkPolicyQueryPageList',
    method: 'post',
    data: data
  });
} // 临港平台理赔报案申请接口

export function claimReportApplyQuery(data) {
  return request({
    url: '/ecargopolicy/rinko/rinkoClaimReportQuery',
    method: 'post',
    data: data
  });
} // 临港平台理赔申请保单查询接口

export function claimReportApplyQueryList(data) {
  return request({
    url: '/ecargopolicy/rinko/rinkoClaimReportApply',
    method: 'post',
    data: data
  });
} // 临港平台理赔申请提交接口

export function rinkoClaimReportApplySubmit(data) {
  return request({
    url: '/ecargopolicy/rinko/rinkoClaimReportApplySubmit',
    method: 'post',
    data: data
  });
} // 临港平台理赔申请查询接口

export function rinkoClaimApplyQUery(data) {
  return request({
    url: '/ecargopolicy/rinko/rinkoClaimApplyQUery',
    method: 'post',
    data: data
  });
} // 临港平台影像上传

export function rinkoImageUploads(data) {
  return request({
    url: '/ecargopolicy/rinkoProposalImageUploads/rinkoImageUploads',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    }
  });
} // 临港平台影像查看

export function rinkoImageView(data) {
  return request({
    url: '/ecargopolicy/rinkoProposalImageUploads/rinkoImageView',
    method: 'post',
    data: data
  });
} // 临港平台影像删除

export function rinkoImageDel(data) {
  return request({
    url: '/ecargopolicy/rinkoProposalImageUploads/rinkoImageDel',
    method: 'post',
    data: data
  });
} // 临港平台理赔申请报案信息和损失信息查询接口

export function claimReportApplyLossQuery(data) {
  return request({
    url: '/ecargopolicy/rinko/rinkoClaimReportLossQuery',
    method: 'post',
    data: data
  });
} // 临港平台理赔申请人身伤害信息查询接口

export function rinkoClaimPersonQuery(data) {
  return request({
    url: '/ecargopolicy/rinko/rinkoClaimPersonQuery',
    method: 'post',
    data: data
  });
} // 临港平台投保单管理查看

export function rinkoLook(data) {
  return request({
    url: '/ecargopolicy/rinko/rinkoLook',
    method: 'post',
    data: data
  });
} // 临港平台理赔保单号补录页面查看

export function rinkoClaimQuery(data) {
  return request({
    url: '/ecargopolicy/rinko/rinkoClaimQuery',
    method: 'post',
    data: data
  });
} // 临港平台理赔申请影像查看

export function rinkoClaimLook(data) {
  return request({
    url: '/ecargopolicy/rinko/rinkoClaimLook',
    method: 'post',
    data: data
  });
} // 临港平台投保单管理作废

export function rinkoUpdateStatus(data) {
  return request({
    url: '/ecargopolicy/rinko/rinkoUpdateStatus',
    method: 'post',
    data: data
  });
} // 临港平台投保单管理作废

export function rinkoApplicationSubmit(data) {
  return request({
    url: '/ecargopolicy/rinko/rinkoApplicationSubmit',
    method: 'post',
    data: data
  });
} // 临港平台投保单提交

export function rinkoBuLuSaveInfo(data) {
  return request({
    url: '/ecargopolicy/rinko/rinkoBuLuSaveInfo',
    method: 'post',
    data: data
  });
} // 投保意向单管理中的查看接口

export function rinkoApplicationCheck(data) {
  return request({
    url: '/ecargopolicy/rinko/rinkoApplicationCheck',
    method: 'post',
    data: data
  });
} // 投保意向单  删除接口

export function applicationNoDelete(data) {
  return request({
    url: '/ecargopolicy/rinko/Delete',
    method: 'post',
    data: data
  });
} // ----------------临港平台投保意向单管理列表查询

export function rinkoLastYearPayAmount(query) {
  return request({
    url: '/ecargoapis/chitps/getCusTax',
    method: 'post',
    data: query
  });
} // ----------------临港首页视频显示

export function rinkoHomePageIsShow(query) {
  return request({
    url: '/ecargoaccount/userInfo/rinkoHomePageIsShow',
    method: 'post',
    data: query
  });
}